import styled from "styled-components";
import { MainTableCell, MainTableRow } from "../shared/Style/Style";

export const PromoCodesHeaderRow = styled(MainTableRow)`
  display: grid;
  grid-template-columns: 0.5fr 1fr 0.7fr 1fr 2fr 1fr 0.8fr 0.3fr;
  grid-gap: 14px;
  align-items: center;
  padding: 5px 0;
`;

export const PromoCodesTableRow = styled(MainTableRow)`
  display: grid;
  grid-template-columns: 0.5fr 1fr 0.7fr 1fr 2fr 1fr 0.8fr 0.3fr;
  grid-gap: 14px;
  cursor: pointer;
  align-items: center;
  padding: 20px 10px;
`;

export const PromoCodesHeadTableCell = styled.div`
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: black;
`;

export const PromoCodesTableCell = styled(MainTableCell)`
  font-size: 14px;
  line-height: 1.2;

  p {
    margin: 0;
  }
`;